import React from 'react';

type Props = {
    children: React.ReactNode;
};

/** Work / case study password gate disabled — renders children directly. */
const WorkPasswordGate: React.FC<Props> = ({ children }) => <>{children}</>;

export default WorkPasswordGate;
